import Workflow from 'models/Workflow';

// The Not Selected outcome's why, resolved to the client-configured labels (OLIO-3357): the reason,
// and the follow-up detail when the reason owed one (the free-typed competitor name, else the
// competitor's own lookup label). Returns null when the referral carries no reason — a Selected or
// all-Denied outcome tombstones `not_selected_reason` to nil, so absence is the correct signal that
// there is nothing to show.
//
// Labels fall back to the raw slug so a reason recorded against a since-archived or renamed lookup
// item still renders (mirrors `Workflow#lookupLabel` / the API's Narrate::NotSelectedDetail). The
// competitor detail has no slug fallback — an unresolvable competitor reads as no detail rather than
// a bare slug, matching how the slideout has always shown it.
//
// Shared by the Referral Outcome card and the SNF slideout so the resolution can't drift; each site
// formats the parts its own way (the card as "Reason – <reason>: <detail>", the slideout as
// "<reason> · Competitor: <detail>").
export interface NotSelectedReason {
  reasonLabel: string;
  detail: string | null;
}

export function resolveNotSelectedReason(workflow: Workflow): NotSelectedReason | null {
  const reason = workflow.valueFor('not_selected_reason')?.value as string | undefined;
  if (!reason) return null;

  const reasonLabel = workflow.lookupLabel('not_selected_reasons', reason) ?? reason;

  const competitor = workflow.valueFor('competitor')?.value as string | undefined;
  const competitorName = workflow.valueFor('competitor_name')?.value as string | undefined;
  const named = competitorName || workflow.lookupLabel('competitors', competitor);
  const detail = competitor && named ? named : null;

  return { reasonLabel, detail };
}
